import React, { useContext } from 'react';
import DailyEngagedUsersContext from '../../../../contexts/DailyEngagedUsersContext';
import { ConsolidatedHeaderComponent } from '../../components/Metrics/ConsolidatedHeader/ConsolidatedHeaderComponent';
import { useDeuConsumptionContext } from '../../../../contexts/Billing/DeuConsumptionContext';
import { BillingMetrics } from '../../../../shared/BillingMetrics';

const CompiledDailyEngagedUserTitleComponent: React.FC = () => {
  const { dateToSearch, currentMonth, content } = useContext(DailyEngagedUsersContext);
  const { compiledDailyEngagedUserDataState } = useDeuConsumptionContext();

  const consumptionArray = compiledDailyEngagedUserDataState.compiledDailyEngagedUserConsumption;

  const dailyMetricItem = consumptionArray.find(
    item => item.metric?.metricId === BillingMetrics.dailyEngagedUser
  ) || consumptionArray[0];

  const quantity = dailyMetricItem?.metric?.quantity ?? 0;

  const compiledContainsDataOnSelectedMonth = compiledDailyEngagedUserDataState.compiledContainsDataOnSelectedMonth;

  return (
    <ConsolidatedHeaderComponent
      infoHeader={content.compiledDailyEngagedUserInformation.plan}
      dateToSearch={dateToSearch}
      currentMonth={currentMonth}
      showConsolidatedBorder={false}
      middleInfoContent={content.compiledDailyEngagedUserInformation.middleInfo}
    />
  );
};

export default CompiledDailyEngagedUserTitleComponent;